import { create } from 'zustand';
const usePageStore = create((set, get) => ({
    shownSection: -1,
    activeSection: -1,
    isLastSection: false,
    shownPage: '',
    activePage: '',
    blockSnap: 0,
    blockFixed: false,
    pageChangeCount: 0,
    setActiveSection: (activeSection) => {
        set({ activeSection });
    },
    setShownSection: (shownSection) => {
        set({ shownSection });
    },
    setLastSection: (isLastSection) => {
        set({ isLastSection });
    },
    setShownPage: (path) => {
        set({ shownPage: path, pageChangeCount: get().pageChangeCount + 1 });
    },
    setActivePage: (path) => {
        set({ activePage: path });
    },
    setBlockSnap: (blockSnap) => {
        set({ blockSnap });
    },
    setBlockFixed: (blockFixed) => {
        set({ blockFixed });
    },
}));
export default usePageStore;
